refreshUuidOnRefocus